import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class MapFade {

    constructor () {
        const objects = document.querySelector('.js-map')
        if(objects) {
            this.init()
        }
    }

    init() {

        const maps = document.querySelectorAll('.js-map')

        maps.forEach(function(item) {

            let tl = gsap.timeline({
                scrollTrigger:{
                    trigger: item,
                    start:"top 90%",
                    markers: false,
                    toggleClass : 'is-in-view',
                    toggleActions : 'play none none none'
                }
            }).from(item.querySelectorAll('.svg-map'), {
                scale : 1.15,
                opacity: 0,
                duration: .8,
                ease: 'power2.out',
                stagger: .2,
                delay: .5
            }, 0)
                .from(item.querySelectorAll('.locations > *'), {
                    opacity: 0,
                    duration: .8,
                    ease: 'power2.out',
                    stagger: .2,
                    delay: .4
                }, .4)

        })
    }
}
export default MapFade;
